import React, { useState, useEffect, useRef } from "react";
import { Link, Outlet, useLocation,useNavigate } from "react-router-dom";
import {
  FiLogOut,
  FiBookOpen,
  FiFileText,
  FiMenu,
  FiX,
  FiChevronDown,
 
} from "react-icons/fi";
import {
  FaStar
 
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import "bootstrap/dist/css/bootstrap.min.css";
import {toast} from "react-toastify"

export default function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path) => location.pathname.startsWith(path);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);
  const [showAdminDropdown, setShowAdminDropdown] = useState(false);
  const [showAddAdminModal, setShowAddAdminModal] = useState(false);
  const [adminName, setAdminName] = useState("Admin");
  const [adminEmail, setAdminEmail] = useState("admin@example.com");
  const [adminInitial, setAdminInitial] = useState("A");

  const dropdownRef = useRef(null);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // const decodeToken = (token) => {
  //   try {
  //     const payload = token.split('.')[1];
  //     return JSON.parse(atob(payload));
  //   } catch (error) {
  //     console.error("Invalid token format", error);
  //     return null;
  //   }
  // };

  // Load admin data from token on mount
  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem("MagazineToken");

      if (!token) {
        toast.error("Please log in to continue.");
        navigate("/login");           // or "/admin/login" — adjust to your route
        return;
      }

      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/verify`, {
          method: "GET",                        // or POST — depends on your backend
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.message || "Token invalid or expired");
        }

        // Token is valid → extract user info
        // (you can also return name/email/role from backend if you want fresher data)
        const name =data.admin.name
        const email = data.admin.email

        setAdminName(name);
        setAdminEmail(email);
        setAdminInitial(name.charAt(0).toUpperCase());

       

      } catch (err) {
        console.error("Token verification failed:", err);
        toast.error("Session invalid or expired. Please log in again.");
        localStorage.removeItem("MagazineToken");
        navigate("/login");
      }
      
    };
    verifyToken();
  }, [navigate]);

   const handleLogout = () => {
  localStorage.removeItem("MagazineToken");
  toast.success("Logged out successfully");  // ← fixed typo
  navigate("/login");  // or "/admin/login" if that's your login route
};

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 992;
      setIsDesktop(desktop);
      if (desktop) {
        setSidebarOpen(false);
        setShowAdminDropdown(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowAdminDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleAddAdmin = async (e) => {
  e.preventDefault();
      const token = localStorage.getItem("MagazineToken")


  const formData = new FormData(e.target);
  const name = formData.get("name");
  const email = formData.get("email");
  const password = formData.get("password");

  if (!name || !email || !password) {
    toast.error ("All fields are required");
    return;
  }

  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/addadmin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        // Do NOT set Content-Type → browser sets correct boundary
      
      },
      body: JSON.stringify({ name, email, password }),
    });

    const data = await res.json();

    if (!res.ok) {
      toast.error(data.message || "Failed to add admin");
      return;
    }


    toast.success("Admin added successfully ");
    setShowAddAdminModal(false); // close modal
    e.target.reset(); // reset form

  } catch (error) {
    console.error("Error adding admin:", error);
    toast.error("Server error. Please try again.");
  }
};


  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh", background: "#f9fafb" }}>
      {/* Fixed Header */}
      <header
        className="shadow-sm d-flex align-items-center px-3 px-lg-4 py-3"
        style={{
          background: "#fff",
          borderBottom: "1px solid #e5e7eb",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: "70px",
          zIndex:1015
        }}
      >
        {/* Mobile Menu Toggle - Only visible on mobile */}
        <button
  className="btn d-lg-none me-3 p-2 rounded-circle d-flex align-items-center justify-content-center"
  onClick={toggleSidebar}
  aria-label="Toggle sidebar"
  style={{
    width: "44px",
    height: "44px",
    background: "linear-gradient(135deg, #4c1d95, #6d28d9)",
    color: "#fff",
    boxShadow: "0 4px 12px rgba(76, 29, 149, 0.3)",
    border: "none",
    transition: "all 0.2s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "scale(1.05)";
    e.currentTarget.style.boxShadow = "0 6px 16px rgba(76, 29, 149, 0.4)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "scale(1)";
    e.currentTarget.style.boxShadow = "0 4px 12px rgba(76, 29, 149, 0.3)";
  }}
>
  {sidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
</button>

        {/* This flex-grow pushes everything after it to the right */}
        <div className="flex-grow-1"></div>

        {/* Right-aligned group: + Add Admin Button + Admin Profile */}
        <div className="d-flex align-items-center gap-3">
          {/* + Add Admin Button */}
          <button
            className="btn px-3 py-2 rounded-3 text-white fw-semibold d-none d-md-block "
            style={{
              background: "linear-gradient(90deg, #4c1d95, #6d28d9)",
              fontSize: "1rem",
              border: "none",
              outline:"none",
                  boxShadow: "0 4px 12px rgba(76, 29, 149, 0.3)",

            }}
            onClick={() => setShowAddAdminModal(true)}
          >
            + Add Admin
          </button>

          {/* Mobile version of Add Admin (smaller, icon-only if needed - optional) */}
          <button
            className="btn px-3 py-2 rounded-3 text-white fw-semibold d-md-none "
            style={{
              background: "linear-gradient(90deg, #4c1d95, #6d28d9)",
              fontSize: "0.9rem",
              border: "none",
              outline:"none",
                  boxShadow: "0 4px 12px rgba(76, 29, 149, 0.3)",

            }}
            onClick={() => setShowAddAdminModal(true)}
          >
            + Add Admin
          </button>

          {/* Admin Profile */}
          <div className="position-relative" ref={dropdownRef}>
            <button
              className="btn d-flex align-items-center gap-2 text-dark "
               style={{
             
              border: "none",
              outline:"none",
            }}
              onClick={() => !isDesktop && setShowAdminDropdown(!showAdminDropdown)}
              aria-label="Admin profile"
            >
              {/* Admin Name & Email - Only on desktop */}
              <div className="text-end d-none d-lg-block">
                <div className="fw-semibold">{adminName}</div>
                <div className="text-muted small">{adminEmail}</div>
              </div>

              {/* Avatar */}
              <div
                className="d-flex justify-content-center align-items-center text-white fw-bold rounded-circle position-relative"
                style={{
                  width: "46px",
                  height: "46px",
                  background: "linear-gradient(135deg, #4c1d95, #6d28d9)",
                  fontSize: "1.4rem",
                      boxShadow: "0 4px 12px rgba(76, 29, 149, 0.3)",

                }}
              >
                {adminInitial}
                {!isDesktop && (
                  <FiChevronDown
                    size={16}
                    className="position-absolute"
                    style={{
                      bottom: "4px",
                      right: "4px",
                      background: "#fff",
                      borderRadius: "50%",
                      color: "#4c1d95",
                    }}
                  />
                )}
              </div>
            </button>

            {/* Mobile Dropdown */}
            {!isDesktop && showAdminDropdown && (
              <div
                className="position-absolute end-0 mt-2 bg-white rounded-3 shadow-lg py-3 px-4"
                style={{
                  width: "270px",
                  zIndex: 1040,
                  border: "1px solid #e5e7eb",
                }}
              >
                <div className="fw-semibold text-dark">{adminName}</div>
                <div className="text-muted small mt-1">{adminEmail}</div>
              </div>
            )}
          </div>
        </div>
      </header>
      <div
        className={`modal fade ${showAddAdminModal ? "show" : ""}`}
        style={{ display: showAddAdminModal ? "block" : "none" }}
        tabIndex="-1"
        aria-hidden={!showAddAdminModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header"                   style={{ color:"black"}}>

              <h5 className="modal-title">Add New Admin</h5>
              <button
                type="button"
                className="btn-close btn-close-black"
                onClick={() => setShowAddAdminModal(false)}
              ></button>
            </div>
            <form onSubmit={handleAddAdmin}>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label fw-semibold">
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    required
                    placeholder="Enter admin name"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label fw-semibold">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    required
                    placeholder="admin@example.com"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label fw-semibold">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    required
                    minLength="6"
                    placeholder="••••••••"
                  />
                </div>
              </div>
              <div className="modal-footer">
                
                <button
                  type="submit"
                  className="btn text-white"
                  style={{ background: "linear-gradient(90deg, #4c1d95, #6d28d9)" }}
                >
                  Add Admin
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal Backdrop */}
      {showAddAdminModal && (
        <div
          className="modal-backdrop fade show"
          onClick={() => setShowAddAdminModal(false)}
        ></div>
      )}

      {/* Sidebar */}
      <aside
        className="d-flex flex-column shadow-lg"
        style={{
          width: "280px",
          flexShrink: 0,
          background: "linear-gradient(180deg, #4c1d95 0%, #6d28d9 100%)",
          color: "#fff",
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          zIndex: 1020,
          transform: sidebarOpen || isDesktop ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 0.3s ease-in-out",
        }}
      >
        <button
          className="btn d-lg-none position-absolute top-0 end-0 mt-2 me-2 text-white"
          onClick={toggleSidebar}
        >
          <FiX size={24} />
        </button>
<div className="p-4 text-center">
  <div className="d-flex justify-content-center">
    <img
      src="/images/About.webp"
      alt="Admin"
      className="rounded-circle mb-3"
      style={{
        width: "90px",
        height: "90px",
        objectFit: "cover",
        border: "4px solid rgba(255,255,255,0.25)",
      }}
    />
  </div>
  <h5 className="mb-1 fw-semibold text-white">
    Prof. (Dr.) Mallikarjuna Rao Dubisetty
  </h5>
</div>

        <nav className="flex-grow-1 px-4 pb-3">
          <ul className="list-unstyled">
            {[
              {to:"/admin/dashboard",label:"Dashboard",icon:MdDashboard},
              { to: "/admin/magazines", label: "Magazines", icon: FiBookOpen },
              { to: "/admin/blogs", label: "Blogs", icon: FiFileText },
              {to:"/admin/highlights",label:"Highlights",icon:FaStar},
            ].map((item) => {
              const Icon = item.icon;
              const active = isActive(item.to);
              return (
                <li key={item.to} className="mb-2">
                  <Link
                    to={item.to}
                    className="d-flex align-items-center gap-3 px-4 py-3 rounded-lg text-white text-decoration-none"
                    style={{
                      background: active ? "rgba(255,255,255,0.15)" : "transparent",
                      fontWeight: active ? "600" : "500",
                      borderLeft: active ? "3px solid #fff" : "none",
                    }}
                    onMouseEnter={(e) =>
                      !active && (e.currentTarget.style.background = "rgba(255,255,255,0.08)")
                    }
                    onMouseLeave={(e) =>
                      !active && (e.currentTarget.style.background = "transparent")
                    }
                    onClick={() => setSidebarOpen(false)}
                  >
                    <Icon size={20} />
                    <span>{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="p-4 pt-0">
          <button
            className="btn w-100 d-flex align-items-center justify-content-center gap-2 fw-medium rounded-lg"
            style={{
              background: "rgba(239,68,68,0.15)",
              color: "#fca5a5",
              border: "1px solid rgba(239,68,68,0.25)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(239,68,68,0.25)";
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(239,68,68,0.15)";
              e.currentTarget.style.color = "#fca5a5";
            }}
            onClick={handleLogout}
          >
            <FiLogOut size={18} />
            Logout
          </button>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="d-lg-none position-fixed inset-0 bg-black bg-opacity-50"
          style={{ zIndex: 1010 }}
          onClick={toggleSidebar}
        />
      )}

      {/* Main Content */}
      <main
        className="flex-grow-1 overflow-auto bg-white"
        style={{
          marginLeft: isDesktop ? "280px" : "0",
          paddingTop: "70px",
          transition: "margin-left 0.3s ease",
          zIndex:1010
        }}
      >
        <div className="p-4 pt-5"
        style={{zindex:1010}}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}